export default __webpack_public_path__ + "058585e052b158245b28dd8aec9df50c.png";